import * as faPaperclip from '@fortawesome/pro-regular-svg-icons/faPaperclip';
export const Paperclip = `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="${faPaperclip.svgPathData}"/>
  </svg>
`;
